import add from "./add.png";
import back from "./back.png";
import subtract from "./subtract.png";
import chart from "./chart.png";
import dashboard from "./dashboard.png";
import input from "./input.png";
import notes from "./notes.png";
import edit from "./edit.png";
import refresh from "./refresh.png";
import check_circle from "./check_circle.png";
import check_circle_green from "./check_circle_green.png";
import person from "./person.png";
import branch from "./branch.png";
import filter from "./filter.png";
import location from "./location.png";
import cancel from "./cancel.png";
import exit from "./exit.png";
import status_check_inactive from "./status_check_inactive.png";
import status_check_filled from "./status_check_filled.png";
import status_check_current from "./status_check_current.png";
import file_search from "./file_search.png";
import submit from "./submit.png";
import _return from "./return.png";

const icons = { 
    add, back, subtract, chart, exit, dashboard, input, notes, 
    filter, cancel, edit, refresh, person, 
    check_circle, check_circle_green, branch, location,
    status_check_inactive, status_check_filled,
    status_check_current, file_search,
    submit, _return
};

export default icons;